export default "__VITE_ASSET__p86znh74__"